export default __webpack_public_path__ + "static/media/ic_android.1a5556b2.svg";